import { HTML5_BOILERPLATE } from './htmlBoilerplate';

const SNIPPETS = {
  html: [
    {
      label: '!',
      insertText: HTML5_BOILERPLATE,
      detail: 'HTML5 boilerplate (Emmet)',
      filterText: '!',
    },
    {
      label: 'html:5',
      insertText: HTML5_BOILERPLATE,
      detail: 'HTML5 boilerplate',
      filterText: 'html:5',
    },
    {
      label: 'h1',
      insertText: '<h1>${1}</h1>',
      detail: 'Heading 1',
    },
    {
      label: 'h2',
      insertText: '<h2>${1}</h2>',
      detail: 'Heading 2',
    },
    {
      label: 'p',
      insertText: '<p>${1}</p>',
      detail: 'Paragraph',
    },
    {
      label: 'a',
      insertText: '<a href="${1:#}">${2:link text}</a>',
      detail: 'Anchor / link',
    },
    {
      label: 'img',
      insertText: '<img src="${1}" alt="${2}" />',
      detail: 'Image',
    },
    {
      label: 'div',
      insertText: '<div>\n\t${1}\n</div>',
      detail: 'Division container',
    },
    {
      label: 'ul>li',
      insertText: '<ul>\n\t<li>${1}</li>\n\t<li>${2}</li>\n\t<li>${3}</li>\n</ul>',
      detail: 'Unordered list with 3 items',
    },
    {
      label: 'ol>li',
      insertText: '<ol>\n\t<li>${1}</li>\n\t<li>${2}</li>\n</ol>',
      detail: 'Ordered list',
    },
    {
      label: 'table',
      insertText:
        '<table>\n\t<thead>\n\t\t<tr>\n\t\t\t<th>${1:Header}</th>\n\t\t</tr>\n\t</thead>\n\t<tbody>\n\t\t<tr>\n\t\t\t<td>${2:Cell}</td>\n\t\t</tr>\n\t</tbody>\n</table>',
      detail: 'Basic table',
    },
    {
      label: 'form',
      insertText:
        '<form action="${1}" method="${2:post}">\n\t<label for="${3:name}">${4:Name}</label>\n\t<input type="text" id="${3:name}" name="${3:name}" />\n\t<button type="submit">${5:Submit}</button>\n</form>',
      detail: 'Simple form',
    },
    {
      label: 'button',
      insertText: '<button type="${1:button}">${2:Click}</button>',
      detail: 'Button',
    },
    {
      label: 'input',
      insertText: '<input type="${1:text}" name="${2}" id="${2}" placeholder="${3}" />',
      detail: 'Input field',
    },
    {
      label: 'link:css',
      insertText: '<link rel="stylesheet" href="${1:styles.css}" />',
      detail: 'Stylesheet link',
    },
    {
      label: 'script:src',
      insertText: '<script src="${1:script.js}"></script>',
      detail: 'External script',
    },
    {
      label: 'section',
      insertText: '<section>\n\t${1}\n</section>',
      detail: 'Section landmark',
    },
    {
      label: 'nav',
      insertText: '<nav>\n\t${1}\n</nav>',
      detail: 'Navigation',
    },
    {
      label: 'header',
      insertText: '<header>\n\t${1}\n</header>',
      detail: 'Page / section header',
    },
    {
      label: 'footer',
      insertText: '<footer>\n\t${1}\n</footer>',
      detail: 'Page footer',
    },
    {
      label: 'video',
      insertText:
        '<video controls width="${1:640}">\n\t<source src="${2:video.mp4}" type="video/mp4" />\n\tYour browser does not support video.\n</video>',
      detail: 'Video with controls',
    },
  ],
  css: [
    {
      label: 'flex',
      insertText: 'display: flex;\njustify-content: ${1:center};\nalign-items: ${2:center};',
      detail: 'Flexbox centering',
    },
    {
      label: 'grid',
      insertText: 'display: grid;\ngrid-template-columns: ${1:1fr 1fr};\ngap: ${2:1rem};',
      detail: 'CSS Grid',
    },
  ],
  c: [
    { label: 'printf', insertText: 'printf("${1:format}", ${2:args});', detail: 'Print formatted output' },
    { label: 'scanf', insertText: 'scanf("${1:%d}", &${2:var});', detail: 'Read formatted input' },
    { label: 'strlen', insertText: 'strlen(${1:str})', detail: 'String length' },
    { label: 'malloc', insertText: 'malloc(${1:size})', detail: 'Allocate memory' },
    { label: 'free', insertText: 'free(${1:ptr});', detail: 'Free memory' },
    { label: 'for', insertText: 'for (${1:int i = 0}; ${2:i < n}; ${3:i++}) {\n\t${4}\n}', detail: 'For loop' },
    { label: 'while', insertText: 'while (${1:condition}) {\n\t${2}\n}', detail: 'While loop' },
    { label: 'if', insertText: 'if (${1:condition}) {\n\t${2}\n}', detail: 'If statement' },
    { label: 'main', insertText: 'int main() {\n\t${1}\n\treturn 0;\n}', detail: 'Main function' },
  ],
  cpp: [
    { label: 'cout', insertText: 'cout << ${1:value} << endl;', detail: 'Standard output' },
    { label: 'cin', insertText: 'cin >> ${1:var};', detail: 'Standard input' },
    { label: 'vector', insertText: 'vector<${1:int}> ${2:v};', detail: 'Dynamic array' },
    { label: 'for', insertText: 'for (${1:int i = 0}; ${2:i < n}; ${3:i++}) {\n\t${4}\n}', detail: 'For loop' },
    { label: 'class', insertText: 'class ${1:Name} {\npublic:\n\t${2}\n};', detail: 'Class definition' },
    { label: 'main', insertText: 'int main() {\n\t${1}\n\treturn 0;\n}', detail: 'Main function' },
  ],
  java: [
    { label: 'System.out.println', insertText: 'System.out.println(${1:value});', detail: 'Print line' },
    { label: 'Scanner', insertText: 'Scanner ${1:sc} = new Scanner(System.in);', detail: 'Scanner input' },
    { label: 'for', insertText: 'for (${1:int i = 0}; ${2:i < n}; ${3:i++}) {\n\t${4}\n}', detail: 'For loop' },
    { label: 'main', insertText: 'public static void main(String[] args) {\n\t${1}\n}', detail: 'Main method' },
    { label: 'class', insertText: 'public class ${1:Main} {\n\t${2}\n}', detail: 'Class definition' },
  ],
  python: [
    { label: 'print', insertText: 'print(${1:value})', detail: 'Print output' },
    { label: 'input', insertText: 'input(${1:"prompt"})', detail: 'Read input' },
    { label: 'for', insertText: 'for ${1:item} in ${2:iterable}:\n\t${3:pass}', detail: 'For loop' },
    { label: 'while', insertText: 'while ${1:condition}:\n\t${2:pass}', detail: 'While loop' },
    { label: 'def', insertText: 'def ${1:name}(${2:args}):\n\t${3:pass}', detail: 'Function definition' },
    { label: 'if', insertText: 'if ${1:condition}:\n\t${2:pass}', detail: 'If statement' },
  ],
  javascript: [
    { label: 'console.log', insertText: 'console.log(${1:value});', detail: 'Log output' },
    { label: 'function', insertText: 'function ${1:name}(${2:args}) {\n\t${3}\n}', detail: 'Function' },
    { label: 'for', insertText: 'for (let ${1:i} = 0; ${2:i < n}; ${3:i++}) {\n\t${4}\n}', detail: 'For loop' },
    { label: 'const', insertText: 'const ${1:name} = ${2:value};', detail: 'Constant declaration' },
  ],
  go: [
    { label: 'fmt.Println', insertText: 'fmt.Println(${1:value})', detail: 'Print line' },
    { label: 'for', insertText: 'for ${1:i} := 0; ${2:i < n}; ${3:i++} {\n\t${4}\n}', detail: 'For loop' },
    { label: 'func', insertText: 'func ${1:name}(${2:args}) ${3:type} {\n\t${4}\n}', detail: 'Function' },
  ],
  rust: [
    { label: 'println!', insertText: 'println!("${1:format}", ${2:args});', detail: 'Print line' },
    { label: 'fn', insertText: 'fn ${1:name}(${2:args}) -> ${3:type} {\n\t${4}\n}', detail: 'Function' },
    { label: 'let', insertText: 'let ${1:name} = ${2:value};', detail: 'Variable binding' },
  ],
};

export function getSnippetsForLanguage(language) {
  return SNIPPETS[language] || [];
}

export function registerSnippetCompletions(monaco, language) {
  const monacoLang = language === 'cpp' ? 'cpp' : language;
  const snippets = getSnippetsForLanguage(language);
  const isHtml = String(language || '').toLowerCase() === 'html';

  return monaco.languages.registerCompletionItemProvider(monacoLang, {
    triggerCharacters: ['.', '(', ' ', '!'],
    provideCompletionItems: (model, position) => {
      const word = model.getWordUntilPosition(position);
      let range = {
        startLineNumber: position.lineNumber,
        endLineNumber: position.lineNumber,
        startColumn: word.startColumn,
        endColumn: word.endColumn,
      };

      // `!` is not treated as a word by Monaco — expand from the char before cursor.
      if (isHtml && position.column > 1) {
        const charBefore = model.getValueInRange({
          startLineNumber: position.lineNumber,
          startColumn: position.column - 1,
          endLineNumber: position.lineNumber,
          endColumn: position.column,
        });
        if (charBefore === '!') {
          range = {
            startLineNumber: position.lineNumber,
            endLineNumber: position.lineNumber,
            startColumn: position.column - 1,
            endColumn: position.column,
          };
        }
      }

      const suggestions = snippets.map((snippet) => ({
        label: snippet.label,
        kind: monaco.languages.CompletionItemKind.Snippet,
        insertText: snippet.insertText,
        insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        detail: snippet.detail,
        filterText: snippet.filterText || snippet.label,
        range,
      }));

      return { suggestions };
    },
  });
}
